import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconIntercom32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconIntercom32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M24 28.143 19 26h-9a4 4 0 0 1-4-4V10a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v19zM24 10v15.967l-4.212-1.805L19.41 24H10a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2m-12.437 8.673a1 1 0 0 0-1.127 1.653L11 19.5l-.563.826.002.002.003.002.008.006.028.018.092.058q.116.074.327.194c.278.156.676.362 1.168.567.977.407 2.361.827 3.935.827s2.958-.42 3.936-.827a11 11 0 0 0 1.494-.76l.092-.06.027-.017.01-.006.002-.002.002-.001L21 19.5l.564.826a1 1 0 0 0-1.127-1.652v-.001l-.01.007-.057.037a9 9 0 0 1-1.204.61C18.344 19.67 17.228 20 16 20s-2.344-.33-3.166-.673a9 9 0 0 1-1.204-.61l-.057-.037zm8.874 0L21 19.5l-.564-.826m0 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconIntercom32);
